/**
 * <b>받는 자리의 표시</b> — 자료실 도크에서 파일을 끌 때 켜지는 자리들이 같은 모양을 쓴다
 * (대화창 · 현장 서류 탭 · 착공서류 줄 · 공정관리 · 원가 증빙 칸 · 공지/지침 첨부칸).
 *
 * <h2>두 단계다</h2>
 * <ul>
 *   <li><b>켜짐</b> — 끌기가 시작된 순간. 「어디에 놓을 수 있는지」를 <b>찾아다니기 전에</b> 알려 준다.
 *       <b>연두색 바탕이 번쩍이고 빛이 밖으로 번진다</b>(사용자 지시 2026-09-04) — 화면 어디에
 *       자리가 있는지 눈이 먼저 찾아야 하므로, 얌전한 표시로는 모자란다. <b>테두리는 두지 않는다</b>:
 *       선을 두르면 그 테가 먼저 읽혀 «초록 상자» 가 된다.</li>
 *   <li><b>겨냥</b> — 그 위에 올라왔을 때. 손을 놓으면 어디로 들어가는지가 분명해야 하므로 선이
 *       바탕이 한 단 짙어지고 빛 번짐이 머무르며 <b>번쩍임은 멈춘다</b>(정해졌다는 뜻이다).</li>
 * </ul>
 *
 * <p>못 받는 자리는 <b>아예 켜지 않는다</b>. 켜 놓고 놓는 순간 거절하면, 사람은 「받는다고 해 놓고
 * 안 받는다」 로 읽는다.
 *
 * <h2>왜 클래스인가 (2026-09-04)</h2>
 * 처음에는 인라인 스타일로 <b>검은빛 점선</b>을 그렸다. 두 가지가 걸렸다 — 색이 강조 남색이라
 * 검게 읽혔고(사용자 지적 「이 검은 점선 꼴보기싫어」), 인라인으로는 <b>번쩍임·빛 번짐</b>을 줄 수 없다. 모양은 `index.css` 의
 * {@code .drop-zone} 한 곳으로 옮기고, 여기서는 <b>어느 단계인지만</b> 고른다 — 색을 바꾸고 싶으면
 * 그 한 곳을 고치면 여섯 자리가 함께 바뀐다({@code .btn-shine} 과 같은 규율).
 */
export function dropZoneClass({
  active,
  over,
  inset = false,
}: {
  active: boolean;
  over: boolean;
  /**
   * 바깥으로 퍼지는 <b>빛 고리를 뺀다</b>. 부모 가장자리에 붙어 있어 그 부분이 잘리는 자리에서
   * 켠다 — AI 대화창 입력칸이 그렇다(도크 맨 아래·좌우 끝에 붙어 있어 한 변만 남았다).
   * 그 자리는 바탕의 번쩍임만으로 말한다.
   */
  inset?: boolean;
}): string {
  if (!active && !over) return '';
  return ['drop-zone', inset ? 'drop-zone-inset' : '', over ? 'drop-zone-over' : ''].filter(Boolean).join(' ');
}
